import React, { useEffect, useState } from "react"
import "../../../../../App.scss"
import { Modal, Form, Input, Row, Col, Spin, InputNumber, Checkbox } from "antd"


import { BlockInfoStyle } from "src/pages/ADMIN/HumanResource/styled"
import { SectionCard } from "../../PurchaseReport/Modal/styled"
import { SectionTitle } from "./styled"
import ReportsService from "src/services/ReportService"
import TableCustom from "src/components/Table/CustomTable"

const ModalViewOrder = ({ open, onCancel, recordId }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [totalQuantity, setTotalQuantity] = useState(0)
  const [totalAmount, setTotalAmount] = useState(0)
  const [selectedTypes, setSelectedTypes] = useState([])
  const [countryId, setCountryId] = useState(null)
  const [totalDataQuantity, setTotalDataQuantity] = useState(0)
  const [note, setNote] = useState(null)
  const [detailTableData, setDetailTableData] = useState([])

  useEffect(() => {
    if (open && recordId) {
      fetchDataDetail()
    }
  }, [open, recordId])

  const fetchDataDetail = async () => {
    setLoading(true)
    try {
      if (recordId) {
        const response = await ReportsService.getReportAgencyPurchaseDetail(
          recordId,
        )
        const detail = response?.success || {}
        const detailSim = detail.sim_details.map((item, index) => ({
          ...item,
          ID: item.ID,
          carrier: item.network?.name,
          sim_type: item.sim_type === "1" ? "IoT" : "Travel",
          sim_unit_price: Number(item.sim_unit_price).toLocaleString(),
          type_sim: item.type_sim === "usim" ? "Sim vật lý" : "E-SIM",
          scope: item.scope === "1" ? "Local" : "Roaming",
          package_name: item.package?.name,
          total_amount: (
            Number(item.sold_sim_count) * Number(item.sim_unit_price)
          ).toLocaleString(),
          sale_mode:
            item.mode === 0
              ? "Bán theo cài đặt giá bán"
              : item.mode === 1
              ? "Bán theo hoa hồng"
              : "_",

          commission: item.mode === 1 ? Number(item.commission) + "%" : "_",
        }))
        setDetailTableData(detailSim)
        setNote(detail.note || null)
        // Determine order types
        const types = []
        if (detail?.sim_details?.length > 0) {
          types.push("sim")
          const hasPackage = detail.sim_details.some(item => item.package_id)
          if (hasPackage) {
            types.push("data")
          }
        }
        if (detail?.data_details?.length > 0) {
          types.push("data")
        }
        setSelectedTypes(types)

        // Calculate totals
        let totalSimQty = 0
        let totalDataQty = 0
        let totalAmt = 0

        // Calculate SIM totals
        if (detail?.sim_details) {
          detail.sim_details.forEach(sim => {
            const qty = Number(sim.sim_quantity) || 0
            const price = Number(sim.sim_unit_price) || 0
            totalSimQty += qty
            totalAmt += qty * price
          })
        }

        setTotalQuantity(totalSimQty)
        setTotalDataQuantity(totalDataQty)
        setTotalAmount(totalAmt)

        // Set form values
        const initialValues = {
          export_code: detail.export_code,
          customer_id: detail.customer?.fullname || "",
          country_id: Number(detail.country_id),
          discount_type: detail.discount_type,
          discount: Number(detail.discount),
          note: detail.note,
        }

        setCountryId(Number(detail.country_id))
        form.setFieldsValue(initialValues)
      }
    } catch (error) {
      console.error("Lỗi:", error)
    } finally {
      setLoading(false)
    }
  }
  const columns = [
    {
      title: "Nhà mạng",
      dataIndex: "carrier",
      key: "carrier",
      align: "center",
    },
    {
      title: "Loại sim",
      dataIndex: "type_sim",
      key: "type_sim",
      align: "center",
    },
    {
      title: "Local/Roaming",
      dataIndex: "scope",
      key: "scope",
      align: "center",
    },
    {
      title: "Loại hình sim",
      dataIndex: "sim_type",
      key: "sim_type",
      align: "center",
    },
    {
      title: "Gói cước",
      dataIndex: "package_name",
      key: "package_name",
      align: "center",
    },

    {
      title: "Đơn giá (VNĐ)",
      dataIndex: "sim_unit_price",
      key: "sim_unit_price",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
    {
      title: "Số lượng",
      dataIndex: "sold_sim_count",
      key: "sold_sim_count",
      align: "center",
    },
    {
      title: "Cách bán",
      dataIndex: "sale_mode",
      key: "sale_mode",
      align: "center",
    },
    {
      title: "Chiết khấu",
      dataIndex: "commission",
      key: "commission",
      align: "center",
    },
    {
      title: "Tổng tiền",
      dataIndex: "total_amount",
      key: "total_amount",
      align: "right",
      onHeaderCell: () => ({
        style: { textAlign: "center" },
      }),
    },
  ]

  return (
    <Modal
      open={open}
      title="Chi tiết báo cáo phần mua"
      onCancel={() => {
        form.resetFields()
        setTotalQuantity(0)
        setTotalAmount(0)
        setTotalDataQuantity(0)
        setSelectedTypes([])
        setNote(null)
        onCancel()
      }}
      width={1400}
      confirmLoading={loading}
      destroyOnClose={true}
      footer={null}
    >
      <Spin spinning={loading}>
        <Form layout="vertical" form={form}>
          <div style={{ position: "relative" }}>
            <Row gutter={16}>
              <Col span={24}>
                <Row gutter={16}>
                  <Col span={6} style={{ marginTop: 38 }}>
                    <strong>Khách hàng: </strong>{" "}
                    {form.getFieldValue("customer_id")}
                  </Col>
                  {selectedTypes.includes("sim") && (
                    <Col span={4} style={{ marginTop: 38 }}>
                      <strong>Tổng số lượng sim: </strong> {totalQuantity}
                    </Col>
                  )}
                  <Col span={6} style={{ marginTop: 38 }}>
                    <strong>Tổng tiền đơn hàng: </strong>
                    {totalAmount.toLocaleString()}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

            <SectionCard>
              <SectionTitle>Thông tin đơn hàng SIM</SectionTitle>
              <TableCustom
                isPrimary
                columns={columns}
                dataSource={detailTableData}
                pagination={false}
                // pagination={{
                //   current: pagination.current,
                //   pageSize: pagination.pageSize,
                //   total: pagination.total,
                //   showSizeChanger: true,
                //   pageSizeOptions: ["10", "20", "50", "100"],
                // }}
                // onChange={handleTableChange}
                // footerLeft={<div className="d-flex mt-20" />}
                widthScroll={1200}
                textEmpty="Không có dữ liệu!"
                scroll={{ x: "max-content" }}
                loading={loading}
              />
            </SectionCard>

          {note && (
            <Row gutter={16}>
              <Col span={24}>
                <Form.Item name="note" label="Ghi chú">
                  <Input.TextArea placeholder="Ghi chú" disabled />
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </Spin>
    </Modal>
  )
}

export default ModalViewOrder
